import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { APPLE_PAY_CONTAINER_ID } from '../../../config/consts.js';
import useAdyenApplePay from '../../../hooks/useAdyenApplePay.js';
import { useTranslation } from '../../../hooks/useTranslations.js';
import { useAppContext } from '../../../providers/AppContextProvider.js';
import styles from './AdyenApplePayButton.module.scss.js';
import '@adyen/adyen-web/dist/adyen.css';

const AdyenApplePayButton = ({ adyenEnvironment, clientKey, countryCode, amount, paymentMethodsResponse, onSubmit, onFatalError, buttonColor = 'black', buttonType = 'buy', currency, siteId, sid, customerId, customerType, }) => {
    const { t } = useTranslation();
    const { locale } = useAppContext();
    useAdyenApplePay({
        adyenEnvironment,
        clientKey,
        locale,
        t,
        countryCode,
        currency,
        amount,
        paymentMethodsResponse,
        onSubmit,
        onFatalError,
        buttonColor,
        buttonType,
        siteId,
        sid,
        customerId,
        customerType,
    });
    return (jsx("div", { id: APPLE_PAY_CONTAINER_ID, className: classNames(styles.applePayContainer, styles.applePayRoundBorder), "data-zta": "adyen-apple-pay-button", "data-testid": "adyen-apple-pay-button" }));
};

export { AdyenApplePayButton as default };
//# sourceMappingURL=AdyenApplePayButton.js.map
